module.exports = __webpack_public_path__ + "media/images/profile-cover-51c6aba39bf903ee80bfc25b872afe67.png";